module.exports = __webpack_public_path__ + "img/yiqing.fa18f5ab.jpg";